import { useState, useContext } from "react";

import { PersonalDetails } from "./personalDetails";
import { FamilyDetails } from "./familyDetails";
import { ContactDetails } from "./contactDetails";
import { BsArrowLeft } from "react-icons/bs";
import { Link } from "react-router-dom";

// import { axiosInstance } from "../../axiosInstance";

import translations from "./translation.json";
import { LanguageContext } from "../../Components/LanguageContext";

export function UserprofileEdit() {
  const { language } = useContext(LanguageContext);
  const [content, setContent] = useState(<PersonalDetails />);
  const [activeMenu, setActiveMenu] = useState("personal");

  function handleBasic() {
    setContent(<PersonalDetails />);
    setActiveMenu("personal");
  }
  function handleFamily() {
    setContent(<FamilyDetails />);
    setActiveMenu("family");
  }
  function handleEducation() {
    setContent(<ContactDetails />);
    setActiveMenu("contact");
  }
  // function handleDocument(){
  //   setContent(<DocumentInfo id={id}/>);
  //   setActiveMenu("document");
  // }
  // function handleOther(){
  //   setContent(<OtherInfo id={id}/>);
  //   setActiveMenu("other");
  // }
  // function handleWallet(){
  //   setContent(<WalletInfo id={id}/>);
  //   setActiveMenu("wallet");
  // }
  return (
    <div className="container">
      <div className="d-flex me-2">
        <div style={{ marginTop: "20px" }}>
          <Link
            to="/view-more"
            style={{
              color: "#2B171B",
              marginRight: "10px",
              fontSize: "20px",
              paddingTop: "20px",
            }}
          >
            {" "}
            <span>
              <BsArrowLeft />
            </span>
          </Link>
        </div>

        <div className="menuContainer">
          <div className="menu">
            <div
              onClick={handleBasic}
              className={activeMenu === "personal" ? "active" : ""}
            >
              {" "}
              {translations[language].personal_details}
            </div>
            <div
              onClick={handleFamily}
              className={activeMenu === "family" ? "active" : ""}
            >
              {" "}
              {translations[language].family_details}
            </div>
            <div
              onClick={handleEducation}
              className={activeMenu === "contact" ? "active" : ""}
            >
              {" "}
              {translations[language].contact_details}
            </div>
            {/* <div onClick={handleDocument}   className={activeMenu === "document" ? "active" : ""}>Documents Information</div> */}
            {/* <div onClick={handleOther}  className={activeMenu === "other" ? "active" : ""}>Other Information</div> */}
            {/* <div onClick={handleWallet}  className={activeMenu === "wallet" ? "active" : ""}>Wallet Information</div> */}
          </div>
        </div>
      </div>
      <div className="content-part">{content}</div>
    </div>
  );
}
